export default __webpack_public_path__ + "static/media/img1.79f598c6.jpg";